/* Discreet pointer from the course pages to /ponude.

   Deliberately a plain text link and not a second button: /educations is the
   site's best-performing result and its own signup form is the conversion
   path there. This only has to be findable, not loud. */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BRAND, sans } from './blocks';
import { linkTo } from '../../i18n/lang.mjs';

const OffersLink = ({ style }) => {
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';

  return (
    <Link
      to={linkTo('/ponude', lang)}
      style={{
        fontFamily: sans,
        fontSize: '15px',
        fontWeight: 600,
        color: BRAND,
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
        ...style,
      }}
    >
      {t('offers.teaser')} →
    </Link>
  );
};

export default OffersLink;
